import { DatePicker } from 'antd'
import { KTIcon } from '../../../_metronic/helpers'
import { useLayout } from '../../../_metronic/layout/core'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'

const SMSReportRightToolbar = () => {
  const { RangePicker } = DatePicker
  const { peIdSmsReport, setPeIdSmsReport, dateFilterSmsReport, setDateFilterSmsReport } = useLayout()

  const handleDateChange = (value: any, dateString: [string, string]) => {
    const [startDate, endDate] = dateString
    const start = dayjs(startDate)
    const end = dayjs(endDate)
    const diffDays = end.diff(start, 'days')
    if (diffDays > 90) {
      Swal.fire({
        titleText: 'Invalid',
        text: 'You can only select a range of up to 90 days.',
        icon: 'error',
        confirmButtonText: 'Ok! Got It',
      })
      return
    }
    setDateFilterSmsReport(dateString)
  }

  return (
    <div className='d-flex align-items-center'>
      <RangePicker
        className='bg-secondary-custom text-white border-0 shadow-none'
        style={{ height: '35px' }}
        onChange={handleDateChange}
        value={
          dateFilterSmsReport?.[0] && dateFilterSmsReport?.[1]
            ? [dayjs(dateFilterSmsReport[0]), dayjs(dateFilterSmsReport[1])]
            : undefined
        }
        disabledDate={(current) => current && current.isAfter(dayjs(), 'day')}
      />
      <div className='d-flex align-items-center position-relative ms-3'>
        <KTIcon iconName='magnifier' className='text-white-500 position-absolute ms-2' />
        <input
          type='text'
          className='form-control form-control-solid form-select-sm w-150px ps-9'
          placeholder='Search Owner ID'
          value={peIdSmsReport}
          onChange={(e) => setPeIdSmsReport(e.target.value)}
        />
      </div>
    </div>
  )
}

export default SMSReportRightToolbar